import { render, staticRenderFns } from "./AssetMap.vue?vue&type=template&id=4720a29b&"
import script from "./AssetMap.vue?vue&type=script&lang=js&"
export * from "./AssetMap.vue?vue&type=script&lang=js&"
import style0 from "./AssetMap.vue?vue&type=style&index=0&id=4720a29b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports